import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getHeadHuntApplicationsSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getHeadHuntApplications, params)
    yield put(actions.getHeadHuntApplicationsSuccess(response?.data?.data))
    yield put(actions.getHeadHuntApplicationsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getHeadHuntApplicationsFinish())
  }
}

function* updateHeadHuntApplicationsSaga(action: ActionModel) {
  try {
    const body: any = action.payload.data
    const response: ResponseModel = yield call(
      service.updateHeadHuntApplications,
      body,
      action.payload?.id
    )
    yield put(actions.updateHeadHuntApplicationsSuccess(response.data?.data))
    yield put(actions.updateHeadHuntApplicationsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateHeadHuntApplicationsFinish())
  }
}

function* deleteHeadHuntApplicationsSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteHeadHuntApplications, body)
    yield put(actions.deleteHeadHuntApplicationsSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteHeadHuntApplicationsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteHeadHuntApplicationsFinish())
  }
}

function* getHeadHuntApplicationSaga(action: ActionModel) {
  try {
    const id: any = action.payload
    const response: ResponseModel = yield call(service.getHeadHuntApplication, id)
    yield put(actions.getHeadHuntApplicationSuccess(response?.data?.data))
    yield put(actions.getHeadHuntApplicationFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getHeadHuntApplicationFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_HEAD_HUNT_APPLICATIONS_START, getHeadHuntApplicationsSaga)
  yield takeLatest(actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_START, updateHeadHuntApplicationsSaga)
  yield takeLatest(actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_START, deleteHeadHuntApplicationsSaga)
  yield takeLatest(actionTypes.GET_HEAD_HUNT_APPLICATION_START, getHeadHuntApplicationSaga)
}
